import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Col } from 'react-bootstrap';
import './styles/section.scss';

const FormSection = ({
  children = null,
  className = '',
  col = { xs: 12, sm: 12, md: 12, lg: 12 },
  controlId,
  hide = false,
  labelAlign = 'left',
  small = false,
  struct = false,
  style = 'default', // TODO 'style' is poor prop choice; small and labelAlign prop are just more class names
  title = '',
}) => {
  const wrapperClassName = classNames('section-wrapper', className, {
    'is-hidden': hide,
    'has-title': !!title,
    [small]: small,
    [style]: true,
    struct,
  });

  const subClassName = struct ? 'structural-section' : 'defined-section';

  const titleAlign = labelAlign || 'left';

  const titleClassName = classNames('section-title-wrapper', {
    [titleAlign]: true,
  });

  const xxlValue = (col && (col.xxl || col.xl || col.lg || col.md)) || 12;

  return (
    <Col
      className={classNames(wrapperClassName, `col-xxl-${xxlValue}`)}
      id={controlId}
      // xxl={{ span: (col && (col.xxl || col.xl || col.lg || col.md)) || 12, offset: col && col.xxlOffset }}
      xl={{ span: (col && (col.xl || col.lg || col.md)) || 12, offset: col && col.xlOffset }}
      lg={{ span: (col && (col.lg || col.md)) || 12, offset: col && col.lgOffset }}
      md={{ span: (col && (col.md || col.sm)) || 12, offset: col && col.mdOffset }}
      sm={{ span: (col && col.sm) || 12, offset: col && col.smOffset }}
      xs={{ span: (col && col.xs) || 12, offset: col && col.xsOffset }}
    >
      <div className={subClassName}>
        {title && (
          <div className={titleClassName}>
            <div className="section-title">{title}</div>
          </div>
        )}
        <div className="section">{children}</div>
      </div>
    </Col>
  );
};

FormSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  col: PropTypes.object,
  controlId: PropTypes.string,
  hide: PropTypes.bool,
  labelAlign: PropTypes.string,
  small: PropTypes.bool,
  struct: PropTypes.bool,
  style: PropTypes.string,
  title: PropTypes.string,
};

export default FormSection;
